import { Space, Typography } from "antd";
import { CustomTextField } from "~/components";
import * as APITypes from "~/API";
import { durationToDisplay } from "~/utils";
import { Duration } from "~/types";
import { useAppTranslation } from "~/hooks/useAppTranslation";

const displayRange = (range?: string | null) => {
  if (!range) return undefined;
  const sp1 = range.split(" ");
  const sp2 = sp1[1].split("/");

  const num = Number(sp1[0]);
  if (num === 0) return undefined;

  const disp1 = durationToDisplay(sp2[0] as Duration);
  if (sp2.length === 1) return `${num} ${disp1}${num > 1 ? "s" : ""}`;
  const disp2 = durationToDisplay(sp2[1] as Duration);
  return `${num} ${disp1}${num > 1 ? "s" : ""} per ${disp2}`;
};

export const ReservationRules = ({
  reservationRule,
}: {
  reservationRule: APITypes.ReservationRule;
}) => {
  const { t } = useAppTranslation();
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(175px, min-content))",
        gap: 10,
      }}
    >
      <Space direction="vertical">
        <Typography.Text strong style={{ marginBottom: 5 }}>
          {t("Requires_Approval")}
        </Typography.Text>
        <CustomTextField
          value={reservationRule.requiresApproval ? "Yes" : "No"}
        />
      </Space>
      <Space direction="vertical">
        <Typography.Text strong style={{ marginBottom: 5 }}>
          {t("Max_Requests")}
        </Typography.Text>
        <CustomTextField value={reservationRule.maxRequests} />
      </Space>
      <Space direction="vertical">
        <Typography.Text strong style={{ marginBottom: 5 }}>
          {t("Max_Duration")}
        </Typography.Text>
        <CustomTextField value={displayRange(reservationRule.maxDuration)} />
      </Space>
      <Space direction="vertical">
        <Typography.Text strong style={{ marginBottom: 5 }}>
          {t("Min_Duration")}
        </Typography.Text>
        <CustomTextField value={displayRange(reservationRule.minDuration)} />
      </Space>
      <Space direction="vertical">
        <Typography.Text strong style={{ marginBottom: 5 }}>
          {t("Furthest_Time")}
        </Typography.Text>
        <CustomTextField value={displayRange(reservationRule.furthestTime)} />
      </Space>
      <Space direction="vertical">
        <Typography.Text strong style={{ marginBottom: 5 }}>
          {t("Closest_Time")}
        </Typography.Text>
        <CustomTextField value={displayRange(reservationRule.closestTime)} />
      </Space>
      <Space direction="vertical">
        <Typography.Text strong style={{ marginBottom: 5 }}>
          {t("Max_Party_Size")}
        </Typography.Text>
        <CustomTextField value={reservationRule.maxPartySize || ""} />
      </Space>
    </div>
  );
};
